import { Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { Title, Meta } from '@angular/platform-browser';
import { DataService, FaqItem } from '../../services/data';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [AsyncPipe],
  template: `
<div class="container mt-4 mb-5">
  <div class="row">
    <div class="col-lg-10 offset-lg-1">
      <h1 class="display-5 mb-4">Tenant FAQ</h1>

      @if (faqs$ | async; as faqs) {
        <div class="accordion shadow-sm" id="faqAccordion">
          @for (faq of faqs; track faq.id; let i = $index) {
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button" [class.collapsed]="i !== 0" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + i">
                  {{ faq.question }}
                </button>
              </h2>
              <div [id]="'collapse' + i" class="accordion-collapse collapse" [class.show]="i === 0" data-bs-parent="#faqAccordion">
                <div class="accordion-body" [innerHTML]="faq.answer">
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="text-center my-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-2">Loading FAQs...</p>
        </div>
      }
    </div>
  </div>
</div>
  `,
  styles: `
    .accordion-button {
      font-weight: bold;
    }
    .accordion-button:not(.collapsed) {
      background-color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
      color: var(--brand-dark, #212529);
    }

    .accordion-button::after {
      filter: brightness(0) saturate(100%) invert(84%) sepia(50%) hue-rotate(345deg) brightness(101%) contrast(93%);
    }
  `,
})
export class Faq {
  faqs$: Observable<FaqItem[]>;

  constructor(private dataService: DataService, private titleService: Title, private metaService: Meta) {
    this.faqs$ = this.dataService.getFaqs();
    this.titleService.setTitle('Tenant FAQ - RentMU.com');
    this.metaService.updateTag({ name: 'description', content: 'Frequently asked questions for tenants of Haker Property Management in Columbia, MO.' });
  }
}
